import React, { useState, useEffect } from 'react';
import Imagen1 from '/home/nadai/Nadai App Starknet Test/src/Papyrus.png';
import Imagen2 from '/home/nadai/Nadai App Starknet Test/src/Kakarot.png';
import Imagen3 from '/home/nadai/Nadai App Starknet Test/src/Beerus.png';
import Imagen4 from '/home/nadai/Nadai App Starknet Test/src/Garaga.png';
import Imagen5 from '/home/nadai/Nadai App Starknet Test/src/starknetjs.png';
import Imagen6 from '/home/nadai/Nadai App Starknet Test/src/sphinx.png';

const EcoStarknet = () => {
  const [imageIndex, setImageIndex] = useState(0);
  
  const images = [   
     {
      url: Imagen1,      
      alt: "Papyrus",      
      projectInfo: "Papyrus será un componente clave de la infraestructura descentralizada de StarkNet, es una implementación de Rust de un nodo completo de StarkNet. Proporcionará las bases para el nuevo StarkNet Sequencer, que mejorará drásticamente el rendimiento de StarkNet, ayudará también a mejorar el rendimiento y la descentralización.",      
      link: "",
      link2: "https://github.com/starkware-libs/papyrus",
      link3: "https://medium.com/starkware/papyrus-an-open-source-starknet-full-node-396f7cd90202",}, 

      
     {      
      url: Imagen2,     
      alt: "Kakarot",      
      projectInfo: "Kakarot es una máquina virtual de Ethereum escrita en Cairo. Significa que se puede implementar en StarkNet, una solución de escalado de capa 2 para Ethereum, y ejecutar cualquier programa de código de bytes EVM. Por lo tanto, Kakarot se puede usar para ejecutar contratos inteligentes de Ethereum en StarkNet. ¡Kakarotto es el súper sayajin zkEVM!",      
      link: "https://www.kakarot.org/",
      link2: "https://github.com/sayajin-labs",
      link3: "https://github.com/sayajin-labs/kakarot",},    
     
     {      
      url: Imagen3,
      alt: "Beerus",
      projectInfo: "Beerus es un cliente ligero de StarkNet inspirado y que usa Helios, (Helios es un cliente ligero de Ethereum totalmente confiable, eficiente y portátil escrito en Rust.) El objetivo principal de Beerus es proporcionar un cliente simple y fácil de usar para consultar el estado global de StarkNet y poder interactuar también con los contratos.",
      link: "",
      link2: "https://github.com/keep-starknet-strange/beerus",
      link3:  "",},    
      
    {      
     url: Imagen4,      
     alt: "Garaga",      
     projectInfo: "Garaga es una biblioteca que puede habilitar operaciones de emparejamiento eficientes en StarkNet escrita en Cairo, mediante el uso de representación polinomial de elementos de campo. Algunos casos de uso interesantes habilitados: (SNARK en StarkNet, KZG, esquemas de cifrado basados en la identidad, esquemas de firma digital BLS)",      
     link: "",
     link2: "https://github.com/keep-starknet-strange/garaga",
     link3: "",},
     
    {      
     url: Imagen5,      
     alt: "Starknetjs",      
     projectInfo: "Starknet.js es una biblioteca que ayuda a conectar su sitio web o su aplicación descentralizada (DAPP) a la red Starknet basada en blockchain, utilizando el lenguaje Javascript/Typescript. Puede conectar su DAPP a varias redes tanto de mainnet como testnet (Red principal Starknet, Starknet testnet 1 y Starknet testnet 2 o Starknet-devnet).",      
     link: "https:///www.starknetjs.com/ ", 
     link2: "https://github.com/0xs34n/starknet.js", 
     link3: "https://www.starknetjs.com/guides/intro",},  

    {      
     url: Imagen6,      
     alt: "Sphinx",      
     projectInfo: "Sphinx es un DEX de Libro de Órdenes de Límite Central (CLOB), de cadena cruzada de forma nativa implementado en StarkNet para liquidación sin confianza y liquidez de activos. Mediante el uso de puentes sin confianza, permitimos a los usuarios de otras cadenas (Ethereum, Polygon, Arbitrum, etc.) depositar activos de forma remota y comerciar utilizando su billetera local.",      
     link: "https://www.sphnx.xyz/", 
     link2: "https://github.com/sphinx-dex", 
     link3: "https://sphinx-docs.gitbook.io/docs/",},  
     
     ];

  useEffect(() => {
    const intervalId = setInterval(() => {
    setImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 15000);
    return () => clearInterval(intervalId);
    }, [images.length]);


return (<div style={{ display: "flex", justifyContent: "center" }}>
  <div style={{ margin: "20px", marginTop: "20px", width: "500px", backgroundColor: "#d7d7f8b3", opacity: "0.9", borderRadius: "10px"  }}>
    <h2>{images[imageIndex].alt}</h2>
    <p>{images[imageIndex].projectInfo}</p>
    <a style={{ display: "inline-block", marginRight: "25px" }} href={images[imageIndex].link} target="_blank" rel="noopener noreferrer">
    🔴Visit Project 
    </a>
    <a style={{ display: "inline-block", marginRight: "25px" }} href={images[imageIndex].link} target="_blank" rel="noopener noreferrer">
    🔴Github
    </a>
    <a style={{ display: "inline-block", marginRight: "10px" }} href={images[imageIndex].link} target="_blank" rel="noopener noreferrer">
    🔴Documentos
    </a>
    <div>
    <button style={{ margin: "8px", padding: "5px", backgroundColor: "#d7d7f8b3", borderRadius: "5px" }} 
            onClick={() => setImageIndex(prevIndex => (prevIndex - 1 + images.length) % images.length)}>
      Previous
    </button>
    <button style={{ margin: "8px", padding: "5px", backgroundColor: "#d7d7f8b3", borderRadius: "5px" }} 
            onClick={() => setImageIndex(prevIndex => (prevIndex + 1) % images.length)}>
      Next
    </button>
    </div>
  </div>
  <img
    src={images[imageIndex].url}
    alt={images[imageIndex].alt}
    style={{ height: "280px", width: "300px", marginRight: "50px", borderRadius: "10px", marginTop: "20px" }}
  />
</div>
);
};
export default EcoStarknet;
